/**
 * Minimal, dependency-free store for the currently authenticated role.
 *
 * Lives outside React so non-React callers (e.g. the Axios request
 * interceptor in src/services/Axios/index.js) can read the active role.
 * RoleContextProvider owns the lifecycle: it sets the role when the role
 * resolves and clears it on unmount / role switch; useSignOut clears it
 * defensively on logout.
 *
 * Fail-open policy: while no role is known (null), the write guard is
 * disengaged. This is safe because every request that can fire before the
 * role loads is a GET (the auth/enrollment/organization bootstrap), and the
 * backend already 403s every FINANCE non-read (web-api-colegios#760).
 * Fail-closed would break the public unauthenticated password-recovery
 * flow, which posts to /accounts/password with no role available.
 */
let activeRole = null

export const FINANCE_WRITE_BLOCKED = 'finance-write-blocked'

export const setActiveRole = (role) => {
  activeRole = role ?? null
}

export const clearActiveRole = () => {
  activeRole = null
}

export const getActiveRole = () => activeRole

export const isFinanceWriteBlocked = (error) =>
  Boolean(error) && typeof error === 'object' && error.code === FINANCE_WRITE_BLOCKED
